import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20anime%20style%20background%20with%20soft%20golden%20evening%20light%2C%20scattered%20manga%20pages%20floating%20in%20the%20air%2C%20gentle%20bokeh%20effect%2C%20dreamy%20warm%20atmosphere%2C%20abstract%20composition%20with%20peach%20and%20amber%20tones%2C%20soft%20focus%2C%20no%20text%2C%20no%20characters&width=1920&height=800&seq=cta-bg-manga&orientation=landscape"
          alt="开始阅读"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl font-heading font-black text-white mb-4 tracking-wide">
          现在就开始你的
          <br />
          漫画之旅吧
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          数千部精彩漫画等你来探索，全部免费阅读，随时随地畅享漫画世界
        </p>
        <Link
          to="/category/shaonian-rexue"
          className="inline-flex items-center gap-3 bg-foreground-950 text-white px-7 py-3.5 rounded-full cursor-pointer hover:bg-foreground-800 transition-colors group"
        >
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500">
            <i className="ri-play-fill text-white text-lg"></i>
          </span>
          <span className="text-base font-medium whitespace-nowrap">开始阅读</span>
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform w-5 h-5 flex items-center justify-center"></i>
        </Link>
      </div>
    </section>
  );
}